import { Tooltip } from '@material-ui/core';

import LocationKO from '@material-ui/icons/NotListedLocation';
import LocationWARNING from '@material-ui/icons/Warning';
import LocationOK from '@material-ui/icons/WhereToVote';
import { useRecordContext, useTranslate } from 'react-admin';

export const geojsonValid = (value) => {
    let r=false;
    if (value) {
        try {
            const json = JSON.parse(value);
            if (
                json && json.type && (
                    ('GeometryCollection' === json.type && json.geometries)
                    ||
                    (['Point','LineString','Polygon','MultiPoint','MultiLineString','MultiPolygon'].indexOf(json.type) >= 0 && json.coordinates)
                )
            ) {
                r=true;
            }
        } catch(e) {
            // not valid
        }
    }
    return r;
};

const GeometryField = ({source}) => {
    const translate = useTranslate();
    const record = useRecordContext();
    if (record?.[source]) {
        if (geojsonValid(record?.[source])) {
            return <Tooltip title={translate("resources.geometry.filled")}>
                <LocationOK className="green" />
            </Tooltip>;
        } else {
            return <Tooltip title={translate("resources.geometry.failed")}>
                <LocationWARNING color="error" />
            </Tooltip>;
        }
    }
    return <Tooltip title={translate("resources.geometry.empty")}>
        <LocationKO color="disabled" />
    </Tooltip>;
};

export default GeometryField;